<template>
  <div class="function-main">
    <div class="item-down">
      <!-- <el-dropdown class="level" trigger="click">
        <span class="level-name">{{ currentLevelName }}</span
        ><i class="el-icon-arrow-down el-icon--right"></i>
        <el-dropdown-menu class="level-dropdown" slot="dropdown">
          <el-dropdown-item v-for="item in levelTypeList" :key="item.level_type" :command="item.level_type">
            <el-collapse :value="colValue">
              <el-collapse-item :name="item.level_type">
                <template slot="title">
                  <div @click.stop="changeCol(item.level_type)" class="title-content">{{ item.type_name }}</div>
                </template>
                <div
                  v-for="level in item.levels"
                  :key="level.id"
                  @click="jumpExamination(level, item.level_type)"
                  class="level-item"
                >
                  {{ level.level_name }}
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-dropdown-item>
          <el-dropdown-item
            ><div class="level-test" @click="jumpSpc()">{{ $t("level_test") }}<i class="el-icon-arrow-right"></i></div
          ></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <!-- 语言 -->
      <el-dropdown class="language" trigger="click" @command="handleCommandLanguage">
        <span class="language-name"
          >{{ currentLanguageTitle }} <span class="content-beta" v-if="isShowBeta">Beta</span></span
        >
        <div class="triangle"></div>
        <el-dropdown-menu class="language-dropdown" slot="dropdown">
          <el-dropdown-item
            v-for="item in languageList"
            :key="item.value"
            :command="item.value"
            :disabled="item.value === currentLanguage"
          >
            {{ item.title }}<span class="content" v-if="item.isBeta">Beta</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 分割线 -->
      <div class="Line_Separator"></div>
      <!-- 币种 -->
      <el-dropdown v-if="isLogin" class="language" trigger="click" @command="setPersonalInfo">
        <span class="language-name">{{ currentCurrencyShorthand || $t('currency_type') }} </span>
        <div class="triangle"></div>
        <el-dropdown-menu class="language-dropdown" slot="dropdown">
          <el-dropdown-item
            v-for="item in currencyList"
            :key="item.code"
            :command="item.code"
            :disabled="item.code === currentCurrency"
          >
            {{ item.description }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <div class="tab-menu">
      <el-dropdown class="tab" trigger="click" @visible-change="tabChange($event)">
        <svg-icon :type="tabStatus ? 'close_mobile' : 'open_mobile'" class="icon-32"></svg-icon>
        <el-dropdown-menu class="tab-dropdown" slot="dropdown">
          <el-dropdown-item v-for="item in tabList" :key="item.key" :command="item.name">
            <div
              @click="jumpPage(item.key)"
              style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center"
            >
              {{ item.name }}
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
  </div>
</template>

<script>
import { setLanguage } from '@/utils/cache'
import { LanguageList } from '@/model/globalData'
import { loadLocale } from '@/locales'
import { mapState, mapGetters, mapActions } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import mixinCurrency from '../mixins/currencyList'
import { apiRequest } from '@/serves/http'
import { IS_CHINA } from '@/config'

export default {
  data() {
    return {
      // 多语言
      currentLanguage: loadLocale(),
      languageList: Object.freeze(LanguageList),
      currentLevelName: '',
      colValue: [],
      tabStatus: false,
      currentCurrency: null, //货币
      currencyList: [],
    }
  },
  mixins: [mixinMixpanel, mixinCurrency],
  watch: {
    currentLevelActive: {
      handler: function (newValue) {
        if (!this.levelId) {
          this.currentLevelName = this.$t('spc_pick_level')
        } else {
          this.currentLevelName = newValue.level_name
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState({
      levelTypeList: (state) => state.level.levelList,
      levelId: (state) => state.level.levelId,
      currency: (state) => state.user.currency,
      levelName: (state) => state.level.level_name,
      givenName: (state) => state.user.given_name,
      familyName: (state) => state.user.family_name,
      gender: (state) => state.user.gender,
      countryName: (state) => state.user.country_name,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    ...mapGetters('level', {
      // 当前激活等级对象信息
      currentLevelActive: 'levelActiveObj',
      levelTypeName: 'levelTypeName',
    }),
    isGrading() {
      return this.$store.state.grade.isGrading
    },
    // 多语言
    currentLanguageTitle() {
      const language = this.languageList.find((item) => item.value === this.currentLanguage)
      switch (language?.value) {
        case 'vi':
          return 'VN'
        case 'en':
          return 'EN'
        case 'zh':
          return '中文'
        case 'mn':
          return 'MN'
        case 'fr':
          return 'FR'
        case 'th':
          return 'TH'
        case 'ja':
          return '日本語'
        default:
          return ''
      }
    },
    isShowBeta() {
      return this.languageList.find((item) => item.value === this.currentLanguage).isBeta
    },
    tabList() {
      return [
        {
          name: this.$t('home_online_practice'),
          key: 'online',
        },
        {
          name: this.$t('home_word_outline'),
          key: 'vocabulary',
        },
        {
          name: this.$t('home_test'),
          key: 'mock',
        },
        {
          name: this.$t('home_test_registration'),
          key: 'registration',
        },
      ]
    },
  },

  methods: {
    handleCommandLanguage(command) {
      window.layer.open({
        title: '',
        closeBtn: false,
        content: this.$i18n.messages[command].sure_change_lang,
        btn: [
          this.$i18n.messages[command].change_lang_ok,
          this.$i18n.messages[command].change_lang_cancel,
        ],
        yes: (index) => {
          window.layer.close(index)
          setLanguage(command)
          window.location.reload()
        },
        btn2: (index) => {
          window.layer.close(index)
        },
      })
    },
    jumpPage(desc) {
      if (desc == 'online') {
        this.$router.push({
          name: 'OnlinePractice',
        })
      } else if (desc == 'vocabulary') {
        this.$router.push({
          name: 'vocabulary',
        })
      } else if (desc == 'mock') {
        let mixpanelParams = {
          people_id: this.peopleId,
          unlimited: this.unlimited,
          exam_type: this.levelName,
        }
        analytics.logEvent('hskweb_papers_click', mixpanelParams)
        // this.$router.push({
        //   path: `/${this.levelTypeName || 'hsk'}/index`,
        // })
        this.$router.push({
          path: `/${this.levelTypeName || 'hsk'}/tests`,
          query: {
            level: `${this.levelTypeName}${this.levelActiveIndex}`,
          },
        })
      } else if (desc == 'registration') {
        window.open(this.currentLevelActive.sign_up_url)
      }
    },
    selectLevel(e) {
      e.stopPropagation()
      e.preventDefault()
    },
    changeCol(val) {
      let deepList = JSON.parse(JSON.stringify(this.colValue))
      let removeIndex = deepList.findIndex((item) => item == val)
      if (removeIndex > -1) {
        deepList.splice(removeIndex, 1)
        this.colValue = deepList
      } else {
        this.colValue = [val]
      }
    },
    jumpExamination(newActive, newLevelType) {
      this.$store
        .dispatch('level/changeLevel', {
          levelType: newLevelType,
          levelId: newActive.id,
          levelIndex: newActive.level_id,
        })
        .then(() => {
          if (
            !['OnlinePracticeIndex', 'vocabulary', 'HSKExamination', 'YCTExamination'].includes(
              this.$router?.history?.current?.name
            )
          ) {
            this.$router.push({
              name: 'OnlinePracticeIndex',
            })
          }
        })
    },
    jumpSpc() {
      this.$router.replace({
        name: 'spcExamination',
      })
    },
    tabChange(status) {
      this.tabStatus = status
    },
  },
}
</script>
<style lang="scss" scoped>
.function-main {
  margin: 12px 0 11px 0;
  // width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .item-down {
    // background: #1c1f33;
    // border-radius: 6px;
    display: flex;
    .language {
      margin-right: 12px;
      .language-name {
        display: inline-block;
        position: relative;
        margin-left: 16px;
        line-height: 24px;
        color: #ffffff;
        font-size: 12px;
        white-space: nowrap;
        &:focus {
          outline: none;
        }
        .content-beta {
          display: inline-block;
          position: absolute;
          font-size: 10px;
          color: #faae56;
          top: -7px;
        }
      }
    }
    .level {
      margin-left: 14px;
      position: relative;
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        width: 1px;
        height: 24px;
        border-left: 1px solid #515571;
        right: -7px;
        top: 3px;
      }
      .level-name {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 24px;
        color: #ffffff;
        &:focus {
          outline: none;
        }
      }
    }
    ::v-deep .el-dropdown {
      height: 30px;
      display: flex;
      align-items: center;
    }
  }
  .tab-menu {
    svg {
      &:focus {
        outline: none;
      }
    }
  }
}
::v-deep.language-dropdown {
  .content {
    display: inline-block;
    font-size: 10px;
    color: #faae56;
    margin-left: 1px;
    vertical-align: 9px;
  }
}
::v-deep .el-collapse {
  .level-item {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #696974;
    margin-left: 3px;
    border-top: 1px solid #efeff1;
  }
}
.triangle {
  position: relative;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid white;
  margin-left: 6px;
}
.Line_Separator {
  width: 1px;
  height: 24px;
  border-radius: 1px;
  background: var(--Wohui-Grey-1, #515571);
}
</style>
